document.addEventListener('DOMContentLoaded', function () {
    let linkMain = document.querySelector('.announcement-bar__dropdown .menu-link--main');
    let dropdawnContent = document.querySelector('.announcement-bar__dropdown-content');
    if (linkMain && dropdawnContent) {
        linkMain.addEventListener("click", function (event) {
            linkMain.classList.toggle('active-main')
            dropdawnContent.classList.toggle('active')
        });

        document.addEventListener("click", function (event) {
            if (!linkMain.contains(event.target)) {
                linkMain.classList.remove('active-main')
                dropdawnContent.classList.remove('active')
            }
        });
    }
});